import { render, staticRenderFns } from "./VisitorNotes.vue?vue&type=template&id=32a40840"
import script from "./VisitorNotes.vue?vue&type=script&lang=js"
export * from "./VisitorNotes.vue?vue&type=script&lang=js"
import style0 from "./VisitorNotes.vue?vue&type=style&index=0&id=32a40840&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports